import store from "../../store/store";

export const componentKey = "FACILITY_MANAGEMENT_SLICE";

const { actions } = store.reducerManager.add({
  key: componentKey,
  addedReducers: {
    setFacilityList: (state, action) => {
      state.facilityList = action.payload;
    },
    setCloseAddFacilityDialog: (state, action) => {
      state.closeAddFacilityDialog = action.payload;
    },
    setBaseCampDetails: (state, action) => {
      state.baseCampDetails = action.payload;
    },
    setCloseDepartmentDialog: (state, action) => {
      state.closeDepartmentDialog = action.payload;
    },
    setDepartmentList: (state, action) => {
      state.departmentList = action.payload;
    },
    getClinicLocationData: (state, action) => {
      state.clinicLocations = action.payload;
    },
    getPatientListData: (state, action) => {
      state.patientListData = action.payload;
    },
    setCloseCreatePatientDrawer: (state, action) => {
      state.closeCreatePatientDrawer = action.payload;
    },
    getInventoriesListData: (state, action) => {
      state.inventoriesList = action.payload;
    },
    setCloseFacilityInventoryAddData: (state, action) => {
      state.closeFacilityInventoryData = action.payload;
    },
    setRolesList: (state, action) => {
      state.rolesList = action.payload;
    },
    setCloseUserDialog: (state, action) => {
      state.closeUserDialog = action.payload;
    },
    setFacilityUserList: (state, action) => {
      state.facilityUserList = action.payload;
    },
    setDeleteFacilityResponse: (state, action) => {
      state.deleteFacilityResponse = action.payload;
    },
    setDeleteDepartmentResponse: (state, action) => {
      state.deleteDepartmentResponse = action.payload;
    },
    setRoomList: (state, action) => {
      state.roomList = action.payload;
    },
    setCloseRoomDialog: (state, action) => {
      state.closeRoomDialog = action.payload;
    },
    setGroupedNotesData: (state, action) => {
      state.groupedNotesData = action.payload;
    },
    setCloseAddNotesDialog: (state, action) => {
      state.closeAddNotesDialog = action.payload;
    },
    setCloseSendBulkDialog: (state, action) => {
      state.closeSendBulkDialog = action.payload;
    },
  },
  initialReducerState: {
    facilityList: {},
    closeAddFacilityDialog: false,
    baseCampDetails: {},
    setCloseDepartmentDialog: false,
    departmentList: {},
    clinicLocations: [],
    patientListData: {},
    inventoriesList: {},
    closeFacilityInventoryData: false,
    closeCreatePatientDrawer: false,
    rolesList: [],
    closeUserDialog: false,
    facilityUserList: {},
    deleteFacilityResponse: null,
    deleteDepartmentResponse: null,
    roomList: {},
    closeRoomDialog: false,
    groupedNotesData: [],
    closeAddNotesDialog: false,
    closeSendBulkDialog: false,
  },
});

export const {
  setFacilityList,
  setCloseAddFacilityDialog,
  setBaseCampDetails,
  setCloseDepartmentDialog,
  setDepartmentList,
  getClinicLocationData,
  getPatientListData,
  getInventoriesListData,
  setCloseCreatePatientDrawer,
  setCloseFacilityInventoryAddData,
  setRolesList,
  setCloseUserDialog,
  setFacilityUserList,
  setDeleteFacilityResponse,
  setDeleteDepartmentResponse,
  setRoomList,
  setCloseRoomDialog,
  setGroupedNotesData,
  setCloseAddNotesDialog,
  setCloseSendBulkDialog,
} = actions;
